export const contactRelinkingModalTranslations = {
  criticalRelinkingMessage: {
    header: 'cng-contact_relinking_modal-critical_relinking_header',
    notInHierarchy: 'cng-contact_relinking_modal-critical_relinking_countries_not_in_hierarchy',
    countriesNotMatch: 'cng-contact_relinking_modal-critical_relinking_countries_not_match',
    domainNotMatch: 'cng-contact_relinking_modal-critical_relinking_domain_not_match',
    useProfilingTicket: 'cng-contact_relinking_modal-critical_relinking_use_profiling_ticket',
  },
  footer: {
    buttons: {
      proceed: 'cng-contact_relinking_modal-footer-buttons_proceed',
      cancel: 'cng-contact_relinking_modal-footer-buttons_cancel',
    },
  },
  welcomeStep: {
    title: 'cng-contact_relinking_modal-welcome_step-title',
    description: 'cng-contact_relinking_modal-welcome_step-description',
    buttons: {
      proceed: 'cng-contact_relinking_modal-welcome_step-buttons-proceed',
      cancel: 'cng-contact_relinking_modal-welcome_step-buttons-cancel',
    },
  },
  reassignRolesStep: {
    title: 'cng-contact_relinking_modal-reassign_roles_step-title',
    description: 'cng-contact_relinking_modal-reassign_roles_step-description',
    warning: 'cng-contact_relinking_modal-reassign_roles_step-warning',
    notAvailableContacts: 'cng-contact_relinking_modal-reassign_roles_step-not-available',
    buttons: {
      proceed: 'cng-contact_relinking_modal-reassign_roles_step-buttons-proceed',
      cancel: 'cng-contact_relinking_modal-reassign_roles_step-buttons-cancel',
    },
  },
  reassignUniqueRoles: {
    title: 'cng-contact_relinking_modal-reassign_unique_roles_step-title',
    description: 'cng-contact_relinking_modal-reassign_unique_roles_step-description',
    warning: 'cng-contact_relinking_modal-reassign_unique_roles_step-warning',
    notAvailableContacts: 'cng-contact_relinking_modal-reassign_unique_roles_step-not-available',

    reassignmentOptions: {
      title: 'cng-contact_relinking_modal-reassignment-option-title',
      keep: 'cng-contact_relinking_modal-reassignment-option-keep',
      remove: 'cng-contact_relinking_modal-reassignment-option-remove',
    },

    reassigningForBranchAndOnline: {
      forRelinkingAndTarget:
        'cng-contact_relinking_modal-reassign_unique_roles_step-for-branch-and-online-1',
      forRelinking:
        'cng-contact_relinking_modal-reassign_unique_roles_step-for-branch-and-online-2',
      forTarget: 'cng-contact_relinking_modal-reassign_unique_roles_step-for-branch-and-online-3',
    },
  },
  reassignFlagsStep: {
    title: 'cng-contact_relinking_modal-reassign_flags_step-title',
    description: 'cng-contact_relinking_modal-reassign_flags_step-description',
    warning: 'cng-contact_relinking_modal-reassign_flags_step-warning',
    notAvailableContacts: 'cng-contact_relinking_modal-reassign_unique_flags_step-not-available',
    buttons: {
      proceed: 'cng-contact_relinking_modal-reassign_flags_step-buttons-proceed',
      cancel: 'cng-contact_relinking_modal-reassign_flags_step-buttons-cancel',
    },
  },
  backupStep: {
    title: 'cng-contact_relinking_modal-backup_step-title',
    description: 'cng-contact_relinking_modal-backup_step-description',
    warning: 'cng-contact_relinking_modal-backup_step-warning',
    content: 'cng-contact_relinking_modal-backup_step-content',
    newContact: 'cng-contact_relinking_modal-backup_step-new_contact',
    buttons: {
      proceed: 'cng-contact_relinking_modal-backup_step-buttons-proceed',
      cancel: 'cng-contact_relinking_modal-backup_step-buttons-cancel',
      create: 'cng-contact_relinking_modal-backup_step-buttons-create',
    },
  },
  completionStep: {
    title: 'cng-contact_relinking_modal-completion_step-title',
    description: 'cng-contact_relinking_modal-completion_step-description',
    backupTitle: 'cng-contact_relinking_modal-completion_step-backup_title',
    backupDescription: 'cng-contact_relinking_modal-completion_step-backup_description',
    reassignedRoles: 'cng-contact_relinking_modal-completion_step-reassigned_roles',
    reassignedUniqueRoles: 'cng-contact_relinking_modal-completion_step-reassigned_unique_roles',
    reassignedFlags: 'cng-contact_relinking_modal-completion_step-reassigned_flags',
    buttons: {
      finish: 'cng-contact_relinking_modal-completion_step-buttons-finish',
    },
  },
  skipConfirm: {
    buttons: {
      confirm: 'cng-contact_relinking_modal-skip_confirm-buttons-confirm',
      cancel: 'cng-contact_relinking_modal-skip_confirm-buttons-cancel',
    },
  },
  reassignmentFlagsSkipConfirm: {
    title: 'cng-contact_relinking_modal-skip_confirm-title',
    description: 'cng-contact_relinking_modal-skip_confirm-description',
  },

  backupSkipConfirm: {
    title: 'cng-contact_relinking_modal-backup-skip_confirm-title',
    description: 'cng-contact_relinking_modal-backup-skip_confirm-description',
  },
  cancelConfirm: {
    title: 'cng-contact_relinking_modal-cancel_confirm-title',
    description: 'cng-contact_relinking_modal-cancel_confirm-description',
    buttons: {
      confirm: 'cng-contact_relinking_modal-cancel_confirm-buttons-confirm',
      cancel: 'cng-contact_relinking_modal-cancel_confirm-buttons-cancel',
    },
  },
}
